export default __webpack_public_path__ + "static/media/Diabetes-Mellitus-2.7e08b08e.jpg";